import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=7c6712a5&scoped=true"
var script = {}
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=7c6712a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6712a5",
  null
  
)

export default component.exports